var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"id":"book-button"}},[_c('el-button',{attrs:{"icon":"el-icon-edit-outline","type":"primary","id":"BannerButton"},on:{"click":_vm.goToForm}},[_vm._v("立即預約")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }